module.exports = __webpack_public_path__ + "img/Z82_07.c0346ac0.jpg";